/* eslint-disable no-mixed-operators */
import React, { useEffect, useRef, useState } from "react";
import useUserStore from "../../store/userSlice";
import { errorToast } from "../../utils/constants";
import VerifyKYC from "./verifyKYC";
import { authenticateFirestore } from "../../utils/helpers/firebase";
import {
  encryptKycString,
  saveUserKycQuestionaire,
} from "../../utils/helpers/utils";
import useNetworkStore from "../../store/networkStore";
import backIcon from "../../assests/page/chevron-left.svg";
import QuestionaireOverlay from "../overlays/questionnaire";
import PartnerQuestionaireOverlay from "../overlays/partnerQuestionnaire";
import { useTranslation } from "react-i18next";

const KYCQuestionnaire = (props) => {
  const { t } = useTranslation();
  const [partnerIdx, setPartnerIdx] = useState(0);
  const defaultCountry = {
    area: "",
    flag: "",
    name: "",
    continent: "",
    code: "",
  };
  let partnerExist = props.KYCQuestionnaire?.partnersDetails?.length > 0;
  let currentPartnerDetails = partnerExist
    ? props.KYCQuestionnaire?.partnersDetails[partnerIdx]
    : {};

  //=====General States======
  const [showPartners, setShowPartners] = useState(false);
  const [partnerStep, setPartnerStep] = useState("1");
  const [entityType, setEntityType] = useState("");
  const [includeEntity, setIncludeEntity] = useState(false);
  const [partnersDetails, setPartnersDetails] = useState(
    props.KYCQuestionnaire?.partnersDetails || [],
  );
  const [moreComapnies, setMoreCompanies] = useState("");

  //=====Form States======
  //TODO: Use Reducer to handle meany states??
  const [_kycQuestionaire, _setKycQuestionaire] = useState(
    props.KYCQuestionnaire || {},
  );
  const [selectedCountry, setSelectedCountry] = useState(
    props.KYCQuestionnaire?.taxResidency || defaultCountry,
  );
  const [selectedCountrySec, setSelectedCountrySec] = useState(
    props.KYCQuestionnaire?.taxResidencySec || defaultCountry,
  );
  const [selectedCountryInc, setSelectedCountryInc] = useState(
    props.KYCQuestionnaire?.registrationCountry || defaultCountry,
  );
  const [searchActive, setSearchActive] = useState(false);
  const [newSearchContent, setNewSearchContent] = useState(null);
  const [countryList, setCountryList] = useState(props.countryList || []);
  const [isCheckboxClicked, setIsCheckboxClicked] = useState(null);
  const [selectedTin, setSelectedTin] = useState(
    props.KYCQuestionnaire?.selectedTin || "",
  );
  const [inputTin, setInputTin] = useState(
    props.KYCQuestionnaire?.inputTin || "",
  );
  const [selectedNoTin, setSelectedNoTin] = useState(
    props.KYCQuestionnaire?.selectedNoTin || "",
  );
  const [selectedOtherTax, setSelectedOtherTax] = useState(
    props.KYCQuestionnaire?.selectedOtherTax || "",
  );
  const [selectedNoTinSec, setSelectedNoTinSec] = useState(
    props.KYCQuestionnaire?.selectedNoTinSec || "",
  );
  const [inputNoTin, setInputNoTin] = useState(
    props.KYCQuestionnaire?.inputNoTin || "",
  );

  const [inputNoTinSec, setInputNoTinSec] = useState(
    props.KYCQuestionnaire?.inputNoTinSec || "",
  );
  const [uploadedDocumentW8, setUploadedDocumentW8] = useState(
    props.KYCQuestionnaire?.uploadedDocumentW8Dt || null,
  );
  const [uploadedDocumentHashW8, setUploadedDocumentHashW8] = useState(
    props.KYCQuestionnaire?.uploadedDocumentW8 || null,
  );
  const [uploadPercentageW8, setUploadPercentageW8] = useState(
    props.KYCQuestionnaire?.uploadedDocumentW8?.length > 0 ? 100.0 : 0.0,
  );
  const [uploadedDocumentUBOSource, setUploadedDocumentUBOSource] = useState(
    props.KYCQuestionnaire?.uploadedDocumentUBOSourceDt || null,
  );
  const [uploadedDocumentHashUBOSource, setUploadedDocumentHashUBOSource] =
    useState(props.KYCQuestionnaire?.uploadedDocumentHashUBOSource || null);
  const [uploadPercentageUBOSource, setUploadPercentageUBOSource] = useState(
    props.KYCQuestionnaire?.uploadPercentageUBOSource?.length > 0 ? 100.0 : 0.0,
  );
  const [uploadedDocumentUBO, setUploadedDocumentUBO] = useState(
    props.KYCQuestionnaire?.uploadedDocumentUBODt || null,
  );
  const [uploadedDocumentHashUBO, setUploadedDocumentHashUBO] = useState(
    props.KYCQuestionnaire?.uploadedDocumentUBO || null,
  );
  const [uploadPercentageUBO, setUploadPercentageUBO] = useState(
    props.KYCQuestionnaire?.uploadedDocumentUBO?.length > 0 ? 100.0 : 0.0,
  );
  const [
    uploadedDocumentProofOfRegulation,
    setUploadedDocumentProofOfRegulation,
  ] = useState(
    props.KYCQuestionnaire?.uploadedDocumentProofOfRegulationDt || null,
  );
  const [
    uploadedDocumentHashProofOfRegulation,
    setUploadedDocumentHashProofOfRegulation,
  ] = useState(
    props.KYCQuestionnaire?.uploadedDocumentProofOfRegulation || null,
  );
  const [
    uploadPercentageProofOfRegulation,
    setUploadPercentageProofOfRegulation,
  ] = useState(
    props.KYCQuestionnaire?.uploadedDocumentProofOfRegulation?.length > 0
      ? 100.0
      : 0.0,
  );
  const [
    uploadedDocumentArticlesOfAssociation,
    setUploadedDocumentArticlesOfAssociation,
  ] = useState(
    props.KYCQuestionnaire?.uploadedDocumentArticlesOfAssociationDt || null,
  );
  const [
    uploadedDocumentHashArticlesOfAssociation,
    setUploadedDocumentHashArticlesOfAssociation,
  ] = useState(
    props.KYCQuestionnaire?.uploadedDocumentArticlesOfAssociation || null,
  );
  const [
    uploadPercentageArticlesOfAssociation,
    setUploadPercentageArticlesOfAssociation,
  ] = useState(
    props.KYCQuestionnaire?.uploadedDocumentArticlesOfAssociation?.length > 0
      ? 100.0
      : 0.0,
  );
  const [
    uploadedDocumentOwnerShipAndCSChart,
    setUploadedDocumentOwnerShipAndCSChart,
  ] = useState(
    props.KYCQuestionnaire?.uploadedDocumentOwnerShipAndCSChartDt || null,
  );
  const [
    uploadedDocumentHashOwnerShipAndCSChart,
    setUploadedDocumentHashOwnerShipAndCSChart,
  ] = useState(
    props.KYCQuestionnaire?.uploadedDocumentOwnerShipAndCSChart || null,
  );
  const [
    uploadPercentageOwnerShipAndCSChart,
    setUploadPercentageOwnerShipAndCSChart,
  ] = useState(
    props.KYCQuestionnaire?.uploadedDocumentOwnerShipAndCSChart?.length > 0
      ? 100.0
      : 0.0,
  );
  const [
    uploadedDocumentRegisterOfDirectors,
    setUploadedDocumentRegisterOfDirectors,
  ] = useState(
    props.KYCQuestionnaire?.uploadedDocumentRegisterOfDirectorsDt || null,
  );
  const [
    uploadedDocumentHashRegisterOfDirectors,
    setUploadedDocumentHashRegisterOfDirectors,
  ] = useState(
    props.KYCQuestionnaire?.uploadedDocumentRegisterOfDirectors || null,
  );
  const [
    uploadPercentageRegisterOfDirectors,
    setUploadPercentageRegisterOfDirectors,
  ] = useState(
    props.KYCQuestionnaire?.uploadedDocumentRegisterOfDirectors?.length > 0
      ? 100.0
      : null,
  );
  const [uploadedDocumentSignatoryList, setUploadedDocumentSignatoryList] =
    useState(props.KYCQuestionnaire?.uploadedDocumentSignatoryListDt || null);
  const [
    uploadedDocumentHashSignatoryList,
    setUploadedDocumentHashSignatoryList,
  ] = useState(props.KYCQuestionnaire?.uploadedDocumentSignatoryList || null);
  const [uploadPercentageSignatoryList, setUploadPercentageSignatoryList] =
    useState(
      props.KYCQuestionnaire?.uploadedDocumentSignatoryList?.length > 0
        ? 100.0
        : 0.0,
    );
  const [uploadedDocumentIdOfDirectors, setUploadedDocumentIdOfDirectors] =
    useState(
      props.KYCQuestionnaire?.uploadedDocumentIdOfDirectorsDt &&
        Array.isArray(props.KYCQuestionnaire?.uploadedDocumentIdOfDirectorsDt)
        ? props.KYCQuestionnaire?.uploadedDocumentIdOfDirectorsDt
        : props.KYCQuestionnaire?.uploadedDocumentIdOfDirectorsDt &&
            !Array.isArray(
              props.KYCQuestionnaire?.uploadedDocumentIdOfDirectorsDt,
            )
          ? [props.KYCQuestionnaire?.uploadedDocumentIdOfDirectorsDt]
          : [],
    );
  const [
    uploadedDocumentHashIdOfDirectors,
    setUploadedDocumentHashIdOfDirectors,
  ] = useState(
    props.KYCQuestionnaire?.uploadedDocumentIdOfDirectors &&
      Array.isArray(props.KYCQuestionnaire?.uploadedDocumentIdOfDirectors)
      ? props.KYCQuestionnaire?.uploadedDocumentIdOfDirectors
      : props.KYCQuestionnaire?.uploadedDocumentIdOfDirectors &&
          !Array.isArray(props.KYCQuestionnaire?.uploadedDocumentIdOfDirectors)
        ? [props.KYCQuestionnaire?.uploadedDocumentIdOfDirectors]
        : [],
  );
  const [uploadPercentageIdOfDirectors, setUploadPercentageIdOfDirectors] =
    useState(
      props.KYCQuestionnaire?.uploadedDocumentIdOfDirectors &&
        Array.isArray(props.KYCQuestionnaire?.uploadedDocumentIdOfDirectors)
        ? new Array(
            props.KYCQuestionnaire?.uploadedDocumentIdOfDirectors?.length,
          ).fill(100)
        : props.KYCQuestionnaire?.uploadedDocumentIdOfDirectors &&
            !Array.isArray(
              props.KYCQuestionnaire?.uploadedDocumentIdOfDirectors,
            )
          ? [100]
          : [0],
    );
  const [uploadedDocumentFATCACRS, setUploadedDocumentFATCACRS] = useState(
    props.KYCQuestionnaire?.uploadedDocumentFATCACRSDt || null,
  );
  const [uploadedDocumentHashFATCACRS, setUploadedDocumentHashFATCACRS] =
    useState(props.KYCQuestionnaire?.uploadedDocumentFATCACRS || null);
  const [uploadPercentageFATCACRS, setUploadPercentageFATCACRS] = useState(
    props.KYCQuestionnaire?.uploadedDocumentFATCACRS?.length > 0 ? 100.0 : 0.0,
  );
  const [uploadedDocumentAMLPolicy, setUploadedDocumentAMLPolicy] = useState(
    props.KYCQuestionnaire?.uploadedDocumentAMLPolicyDt || null,
  );
  const [uploadedDocumentHashAMLPolicy, setUploadedDocumentHashAMLPolicy] =
    useState(props.KYCQuestionnaire?.uploadedDocumentAMLPolicy || null);
  const [uploadPercentageAMLPolicy, setUploadPercentageAMLPolicy] = useState(
    props.KYCQuestionnaire?.uploadedDocumentAMLPolicy?.length > 0 ? 100.0 : 0.0,
  );
  const [uploadedDocumentAnnualReport, setUploadedDocumentAnnualReport] =
    useState(props.KYCQuestionnaire?.uploadedDocumentAnnualReportDt || null);
  const [
    uploadedDocumentHashAnnualReport,
    setUploadedDocumentHashAnnualReport,
  ] = useState(props.KYCQuestionnaire?.uploadedDocumentAnnualReport || null);
  const [uploadPercentageAnnualReport, setUploadPercentageAnnualReport] =
    useState(
      props.KYCQuestionnaire?.uploadedDocumentAnnualReport?.length > 0
        ? 100.0
        : 0.0,
    );
  const [selectedTinSec, setSelectedTinSec] = useState(
    props.KYCQuestionnaire?.selectedTinSec || "",
  );

  const [uploadedDocumentTax, setUploadedDocumentTax] = useState(
    props.KYCQuestionnaire?.uploadedDocumentTaxDt || null,
  );

  const [uploadedDocumentHashTax, setUploadedDocumentHashTax] = useState(
    props.KYCQuestionnaire?.uploadedDocumentTax || null,
  );
  const [uploadPercentageTax, setUploadPercentageTax] = useState(
    props.KYCQuestionnaire?.uploadedDocumentTax?.length > 0 ? 100.0 : 0.0,
  );

  const [selectedUserType, setSelectedUserType] = useState(
    props.KYCQuestionnaire?.selectedUserType || "",
  );

  const [inputPep, setInputPep] = useState(
    props.KYCQuestionnaire?.inputPep || "",
  );
  const [inputWallet1, setInputWallet1] = useState(
    props.KYCQuestionnaire?.inputWallet1 || "",
  );
  const [inputWallet2, setInputWallet2] = useState(
    props.KYCQuestionnaire?.inputWallet2 || "",
  );
  const [inputWallet3, setInputWallet3] = useState(
    props.KYCQuestionnaire?.inputWallet3 || "",
  );
  const [inputWallet4, setInputWallet4] = useState(
    props.KYCQuestionnaire?.inputWallet4 || "",
  );
  const [inputName, setInputName] = useState(
    props.KYCQuestionnaire?.inputName || "",
  );
  const [inputEmail, setInputEmail] = useState(
    props.KYCQuestionnaire?.inputEmail || "",
  );
  const [inputDate, setInputDate] = useState(
    props.KYCQuestionnaire?.inputDate || "",
  );
  const [inputWebsite, setInputWebsite] = useState(
    props.KYCQuestionnaire?.inputWebsite || "",
  );
  const [inputAddress, setInputAddress] = useState(
    props.KYCQuestionnaire?.inputAddress || "",
  );

  //===patners states=====

  const [partnerInputName, setPartnerInputName] = useState(
    currentPartnerDetails?.partnerInputName || "",
  );
  const [partnerInputEmail, setPartnerInputEmail] = useState(
    currentPartnerDetails?.partnerInputEmail || "",
  );
  const [partnerInputDate, setPartnerInputDate] = useState(
    currentPartnerDetails?.partnerInputDate || "",
  );
  const [partnerInputWebsite, setPartnerInputWebsite] = useState(
    currentPartnerDetails?.partnerInputWebsite || "",
  );
  const [partnerInputAddress, setPartnerInputAddress] = useState(
    currentPartnerDetails?.partnerInputAddress || "",
  );

  const [partnerUploadedDocumentW8, setPartnerUploadedDocumentW8] = useState(
    currentPartnerDetails?.partnerUploadedDocumentW8Dt || null,
  );
  const [partnerUploadedDocumentHashW8, setPartnerUploadedDocumentHashW8] =
    useState(currentPartnerDetails?.partnerUploadedDocumentW8 || null);
  const [partnerUploadPercentageW8, setPartnerUploadPercentageW8] = useState(
    currentPartnerDetails?.partnerUploadedDocumentW8?.length > 0 ? 100 : 0.0,
  );
  const [
    partnerUploadedDocumentUBOSource,
    setPartnerUploadedDocumentUBOSource,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentUBOSourceDt || null,
  );
  const [
    partnerUploadedDocumentHashUBOSource,
    setPartnerUploadedDocumentHashUBOSource,
  ] = useState(currentPartnerDetails?.partnerUploadedDocumentUBOSource || null);
  const [
    partnerUploadPercentageUBOSource,
    setPartnerUploadPercentageUBOSource,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentUBOSource?.length > 0
      ? 100
      : 0.0,
  );
  const [partnerUploadedDocumentUBO, setPartnerUploadedDocumentUBO] = useState(
    currentPartnerDetails?.partnerUploadedDocumentUBODt || null,
  );
  const [partnerUploadedDocumentHashUBO, setPartnerUploadedDocumentHashUBO] =
    useState(currentPartnerDetails?.partnerUploadedDocumentUBO || null);
  const [partnerUploadPercentageUBO, setPartnerUploadPercentageUBO] = useState(
    currentPartnerDetails?.partnerUploadedDocumentUBO?.length ? 100 : 0.0,
  );
  const [
    partnerUploadedDocumentProofOfRegulation,
    setPartnerUploadedDocumentProofOfRegulation,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentProofOfRegulationDt || null,
  );

  const [
    partnerUploadedDocumentHashProofOfRegulation,
    setPartnerUploadedDocumentHashProofOfRegulation,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentProofOfRegulation || null,
  );

  const [
    partnerUploadPercentageProofOfRegulation,
    setPartnerUploadPercentageProofOfRegulation,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentProofOfRegulation?.length > 0
      ? 100.0
      : 0.0,
  );

  const [
    partnerUploadedDocumentArticlesOfAssociation,
    setPartnerUploadedDocumentArticlesOfAssociation,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentArticlesOfAssociationDt ||
      null,
  );

  const [
    partnerUploadedDocumentHashArticlesOfAssociation,
    setPartnerUploadedDocumentHashArticlesOfAssociation,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentArticlesOfAssociation || null,
  );

  const [
    partnerUploadPercentageArticlesOfAssociation,
    setPartnerUploadPercentageArticlesOfAssociation,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentArticlesOfAssociation
      ?.length > 0
      ? 100.0
      : 0.0,
  );

  const [
    partnerUploadedDocumentOwnerShipAndCSChart,
    setPartnerUploadedDocumentOwnerShipAndCSChart,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentOwnerShipAndCSChartDt || null,
  );

  const [
    partnerUploadedDocumentHashOwnerShipAndCSChart,
    setPartnerUploadedDocumentHashOwnerShipAndCSChart,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentOwnerShipAndCSChart || null,
  );

  const [
    partnerUploadPercentageOwnerShipAndCSChart,
    setPartnerUploadPercentageOwnerShipAndCSChart,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentOwnerShipAndCSChart?.length >
      0
      ? 100.0
      : 0.0,
  );

  const [
    partnerUploadedDocumentRegisterOfDirectors,
    setPartnerUploadedDocumentRegisterOfDirectors,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentRegisterOfDirectorsDt || null,
  );

  const [
    partnerUploadedDocumentHashRegisterOfDirectors,
    setPartnerUploadedDocumentHashRegisterOfDirectors,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentRegisterOfDirectors || null,
  );

  const [
    partnerUploadPercentageRegisterOfDirectors,
    setPartnerUploadPercentageRegisterOfDirectors,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentRegisterOfDirectors?.length >
      0
      ? 100.0
      : 0.0,
  );

  const [
    partnerUploadedDocumentSignatoryList,
    setPartnerUploadedDocumentSignatoryList,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentSignatoryListDt || null,
  );

  const [
    partnerUploadedDocumentHashSignatoryList,
    setPartnerUploadedDocumentHashSignatoryList,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentSignatoryList || null,
  );

  const [
    partnerUploadPercentageSignatoryList,
    setPartnerUploadPercentageSignatoryList,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentSignatoryList?.length > 0
      ? 100.0
      : 0.0,
  );

  const [
    partnerUploadedDocumentIdOfDirectors,
    setPartnerUploadedDocumentIdOfDirectors,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentIdOfDirectorsDt || null,
  );

  const [
    partnerUploadedDocumentHashIdOfDirectors,
    setPartnerUploadedDocumentHashIdOfDirectors,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentIdOfDirectors || null,
  );

  const [
    partnerUploadPercentageIdOfDirectors,
    setPartnerUploadPercentageIdOfDirectors,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentIdOfDirectors?.length > 0
      ? 100.0
      : 0.0,
  );

  const [partnerUploadedDocumentFATCACRS, setPartnerUploadedDocumentFATCACRS] =
    useState(currentPartnerDetails?.partnerUploadedDocumentFATCACRSDt || null);

  const [
    partnerUploadedDocumentHashFATCACRS,
    setPartnerUploadedDocumentHashFATCACRS,
  ] = useState(currentPartnerDetails?.partnerUploadedDocumentFATCACRS || null);

  const [partnerUploadPercentageFATCACRS, setPartnerUploadPercentageFATCACRS] =
    useState(
      currentPartnerDetails?.partnerUploadedDocumentFATCACRS?.length > 0
        ? 100.0
        : 0.0,
    );

  const [
    partnerUploadedDocumentAMLPolicy,
    setPartnerUploadedDocumentAMLPolicy,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentAMLPolicyDt || null,
  );

  const [
    partnerUploadedDocumentHashAMLPolicy,
    setPartnerUploadedDocumentHashAMLPolicy,
  ] = useState(currentPartnerDetails?.partnerUploadedDocumentAMLPolicy || null);

  const [
    partnerUploadPercentageAMLPolicy,
    setPartnerUploadPercentageAMLPolicy,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentAMLPolicy?.length > 0
      ? 100.0
      : 0.0,
  );

  const [
    partnerUploadedDocumentAnnualReport,
    setPartnerUploadedDocumentAnnualReport,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentAnnualReportDt || null,
  );

  const [
    partnerUploadedDocumentHashAnnualReport,
    setPartnerUploadedDocumentHashAnnualReport,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentAnnualReport || null,
  );

  const [
    partnerUploadPercentageAnnualReport,
    setPartnerUploadPercentageAnnualReport,
  ] = useState(
    currentPartnerDetails?.partnerUploadedDocumentAnnualReport?.length > 0
      ? 100.0
      : 0.0,
  );
  const [partnerSelectedCountryInc, setPartnerSelectedCountryInc] = useState(
    currentPartnerDetails?.partnerSelectedCountryInc || defaultCountry,
  );

  const { userAddress } = useUserStore();
  const { chainId, signer, name, provider } = useNetworkStore();

  const nonCompany = [
    "Retail Individual Investor",
    "Professional / Accredited Individual Investor",
  ];

  useEffect(() => {
    const authenticatedUploads = async () => {
      await authenticateFirestore(
        props?.hashedUserAddress,
        props?.hashedUserId,
        process.env.REACT_APP_KYC_DB,
      );
    };

    if (props?.hashedUserAddress > 0 && props?.hashedUserId?.length > 0) {
      authenticatedUploads();
    }
  }, [props?.hashedUserAddress, props?.hashedUserId]);

  const handleUploadQuestioaire = async () => {
    if (!selectedCountry?.name) {
      errorToast("Invalid Tax Residency", "Select a valid tax residency");
      return;
    }
    if (selectedOtherTax === "yes" && !selectedCountrySec?.name) {
      errorToast("Invalid Tax Residency", "Select a valid tax residency");
      return;
    }
    if (selectedTin === "") {
      errorToast(
        "Invalid TIN/Equivalent",
        "Select Yes or No for TIN/Equivalent",
      );
      return;
    }
    if (selectedTin === "") {
      errorToast(
        "Invalid TIN/Equivalent",
        "Select Yes or No for TIN/Equivalent",
      );
      return;
    }

    if (selectedTin === "yes" && inputTin === "") {
      errorToast("Invalid TIN/Equivalent", "Input a valid TIN/Equivalent");
      return;
    }

    if (selectedTin === "yes" && uploadedDocumentHashTax?.length === 0) {
      errorToast(
        "Invalid TIN/Equivalent document",
        "Upload a valid TIN/Equivalent document",
      );
      return;
    }

    if (selectedTin === "no" && selectedNoTin === "") {
      errorToast(
        "Invalid reason for no TIN/Equivalent",
        "Select a valid reason why you have no TIN/Equivalent",
      );
      return;
    }
    if (
      selectedTin === "no" &&
      selectedNoTin ===
        "It is impossible for the above mentioned Client to obtain a TIN for the following reason" &&
      inputNoTin === ""
    ) {
      errorToast(
        "Invalid reason for no TIN/Equivalent",
        "Input a valid reason why it is impossible to obtain TIN/Equivalent",
      );
      return;
    }

    if (selectedUserType === "") {
      errorToast("Invalid User Type", "Select a valid user type.");
      return;
    }
    if (inputPep === "") {
      errorToast("Invalid PEP status", "Input a valid PEP status");
      return;
    }
    props.setCustomLoading(true);

    const saveUsetKyc = await saveUserKycQuestionaire(
      userAddress,
      chainId,
      name,
      signer,
      provider,
      _kycQuestionaire,
      props?.hashedUserAddress,
      true,
      false,
    );

    // console.log("saveUsetKyc...", saveUsetKyc);

    if (saveUsetKyc) {
      //delete localStorage??
      localStorage.removeItem(`${userAddress?.toLowerCase()}-kyc-aml`);
      //refresh pending questionaire
      props?.generalDataProps?.setRefereshQuestionaire(
        !props?.generalDataProps?.refreshQuestionaire,
      );
      if (!props.mobileScreen) {
        if (saveUsetKyc) {
          props.setCustomLoading(false);
          props.setPopupContentPosition("center");
          props.setPopupContent(
            <VerifyKYC
              setShowPopup={props.setShowPopup}
              setPopupContent={props.setPopupContent}
              setPopupContentPosition={props.setPopupContentPosition}
              setCustomLoading={props.setCustomLoading}
              additionalProps={props.additionalProps}
              generalDataProps={props.generalDataProps}
              kycCompleted={true}
              showPortal={true}
            />,
          );
          props.setShowPopup(true);
        } else {
          props.setCustomLoading(false);
          props.setPopupContentPosition("center");
          props.setPopupContent(
            <VerifyKYC
              setShowPopup={props.setShowPopup}
              setPopupContent={props.setPopupContent}
              setPopupContentPosition={props.setPopupContentPosition}
              setCustomLoading={props.setCustomLoading}
              additionalProps={props.additionalProps}
              generalDataProps={props.generalDataProps}
              kycError={true}
              showPortal={true}
            />,
          );
          props.setShowPopup(true);
        }
      } else {
        if (saveUsetKyc) {
          props.setCustomLoading(false);
          props.setPopupContentPosition("center");
          props.setPopupContent(null);
          props.setShowPopup(false);
          props.mobileAction?.setKycCompleted(true);
          props.mobileAction?.setKycError(false);
          props.mobileAction?.setShowSumsubPortal(true);
        } else {
          props.setCustomLoading(false);
          props.setPopupContentPosition("center");
          props.setPopupContent(null);
          props.setShowPopup(false);
          props.mobileAction?.setKycCompleted(false);
          props.mobileAction?.setKycError(true);
          props.mobileAction?.setShowSumsubPortal(true);
        }
      }
    } else {
      props.setCustomLoading(false);
      errorToast(
        "Oops Something went wrong",
        "Unexpected error . Try again later",
      );
    }
  };

  const clearAllPartnerTempFiles = () => {
    setPartnerUploadPercentageAnnualReport(0.0);
    setPartnerUploadedDocumentHashAnnualReport(null);
    setPartnerUploadedDocumentAnnualReport(null);

    setPartnerUploadPercentageAMLPolicy(0.0);
    setPartnerUploadedDocumentHashAMLPolicy(null);
    setPartnerUploadedDocumentAMLPolicy(null);

    setPartnerUploadPercentageFATCACRS(0.0);
    setPartnerUploadedDocumentHashFATCACRS(null);
    setPartnerUploadedDocumentFATCACRS(null);

    setPartnerUploadPercentageIdOfDirectors(0.0);
    setPartnerUploadedDocumentHashIdOfDirectors(null);
    setPartnerUploadedDocumentIdOfDirectors(null);

    setPartnerUploadPercentageSignatoryList(0.0);
    setPartnerUploadedDocumentHashSignatoryList(null);
    setPartnerUploadedDocumentSignatoryList(null);

    setPartnerUploadPercentageRegisterOfDirectors(0.0);
    setPartnerUploadedDocumentHashRegisterOfDirectors(null);
    setPartnerUploadedDocumentRegisterOfDirectors(null);

    setPartnerUploadPercentageOwnerShipAndCSChart(0.0);
    setPartnerUploadedDocumentHashOwnerShipAndCSChart(null);
    setPartnerUploadedDocumentOwnerShipAndCSChart(null);

    setPartnerUploadPercentageArticlesOfAssociation(0.0);
    setPartnerUploadedDocumentHashArticlesOfAssociation(null);
    setPartnerUploadedDocumentArticlesOfAssociation(null);

    setPartnerUploadPercentageProofOfRegulation(0.0);
    setPartnerUploadedDocumentHashProofOfRegulation(null);
    setPartnerUploadedDocumentProofOfRegulation(null);

    setPartnerUploadPercentageUBO(0.0);
    setPartnerUploadedDocumentHashUBO(null);
    setPartnerUploadedDocumentUBO(null);

    setPartnerUploadPercentageUBOSource(0.0);
    setPartnerUploadedDocumentHashUBOSource(null);
    setPartnerUploadedDocumentUBOSource(null);

    setPartnerUploadPercentageW8(0.0);
    setPartnerUploadedDocumentHashW8(null);
    setPartnerUploadedDocumentW8(null);
  };

  return (
    <div
      style={
        props.mobileScreen
          ? {
              display: "unset",
              alignContent: "center",
              justifyContent: "center",
              width: "100%",
            }
          : { display: "unset" }
      }
      className="verify-kyc-popup"
    >
      <div className="verify-kyc-content">
        {showPartners && Number(partnerStep) < 3 && (
          <div className="add-funds-content-header">
            <div className="add-funds-content-header-text-container">
              {partnerStep === "1" && (
                <img
                  className="profile-popup-icon"
                  onClick={() => {
                    if (partnersDetails?.length > 0) {
                      setPartnerIdx(partnersDetails?.length - 1);
                      setPartnerStep("3");
                      setMoreCompanies("Yes");
                      setShowPartners(true);
                    } else {
                      setShowPartners(false);
                    }
                  }}
                  alt="Close Icon"
                  src={backIcon}
                />
              )}
              {Number(partnerStep) > 1 && (
                <img
                  className="profile-popup-icon"
                  onClick={() => {
                    setPartnerStep(String(Number(partnerStep) - 1));
                    setShowPartners(true);
                  }}
                  alt="Close Icon"
                  src={backIcon}
                />
              )}
            </div>
          </div>
        )}

        {!showPartners && (
          <QuestionaireOverlay
            formStates={{
              _kycQuestionaire: _kycQuestionaire,
              _setKycQuestionaire: _setKycQuestionaire,
              selectedCountry: selectedCountry,
              setSelectedCountry: setSelectedCountry,
              selectedCountrySec: selectedCountrySec,
              setSelectedCountrySec: setSelectedCountrySec,
              selectedCountryInc: selectedCountryInc,
              setSelectedCountryInc: setSelectedCountryInc,
              searchActive: searchActive,
              setSearchActive: setSearchActive,
              newSearchContent: newSearchContent,
              setNewSearchContent: setNewSearchContent,
              countryList: countryList,
              setCountryList: setCountryList,
              isCheckboxClicked: isCheckboxClicked,
              setIsCheckboxClicked: setIsCheckboxClicked,
              selectedTin: selectedTin,
              setSelectedTin: setSelectedTin,
              inputTin: inputTin,
              setInputTin: setInputTin,
              selectedNoTin: selectedNoTin,
              setSelectedNoTin: setSelectedNoTin,
              selectedOtherTax: selectedOtherTax,
              setSelectedOtherTax: setSelectedOtherTax,
              selectedNoTinSec: selectedNoTinSec,
              setSelectedNoTinSec: setSelectedNoTinSec,
              inputNoTin: inputNoTin,
              setInputNoTin: setInputNoTin,
              inputNoTinSec: inputNoTinSec,
              setInputNoTinSec: setInputNoTinSec,
              uploadedDocumentW8: uploadedDocumentW8,
              setUploadedDocumentW8: setUploadedDocumentW8,
              uploadedDocumentHashW8: uploadedDocumentHashW8,
              setUploadedDocumentHashW8: setUploadedDocumentHashW8,
              uploadPercentageW8: uploadPercentageW8,
              setUploadPercentageW8: setUploadPercentageW8,
              uploadedDocumentUBOSource: uploadedDocumentUBOSource,
              setUploadedDocumentUBOSource: setUploadedDocumentUBOSource,
              uploadedDocumentHashUBOSource: uploadedDocumentHashUBOSource,
              setUploadedDocumentHashUBOSource:
                setUploadedDocumentHashUBOSource,
              uploadPercentageUBOSource: uploadPercentageUBOSource,
              setUploadPercentageUBOSource: setUploadPercentageUBOSource,
              uploadedDocumentUBO: uploadedDocumentUBO,
              setUploadedDocumentUBO: setUploadedDocumentUBO,
              uploadedDocumentHashUBO: uploadedDocumentHashUBO,
              setUploadedDocumentHashUBO: setUploadedDocumentHashUBO,
              uploadPercentageUBO: uploadPercentageUBO,
              setUploadPercentageUBO: setUploadPercentageUBO,
              uploadedDocumentProofOfRegulation:
                uploadedDocumentProofOfRegulation,
              setUploadedDocumentProofOfRegulation:
                setUploadedDocumentProofOfRegulation,
              uploadedDocumentHashProofOfRegulation:
                uploadedDocumentHashProofOfRegulation,
              setUploadedDocumentHashProofOfRegulation:
                setUploadedDocumentHashProofOfRegulation,
              uploadPercentageProofOfRegulation:
                uploadPercentageProofOfRegulation,
              setUploadPercentageProofOfRegulation:
                setUploadPercentageProofOfRegulation,
              uploadedDocumentArticlesOfAssociation:
                uploadedDocumentArticlesOfAssociation,
              setUploadedDocumentArticlesOfAssociation:
                setUploadedDocumentArticlesOfAssociation,
              uploadedDocumentHashArticlesOfAssociation:
                uploadedDocumentHashArticlesOfAssociation,
              setUploadedDocumentHashArticlesOfAssociation:
                setUploadedDocumentHashArticlesOfAssociation,
              uploadPercentageArticlesOfAssociation:
                uploadPercentageArticlesOfAssociation,
              setUploadPercentageArticlesOfAssociation:
                setUploadPercentageArticlesOfAssociation,
              uploadedDocumentOwnerShipAndCSChart:
                uploadedDocumentOwnerShipAndCSChart,
              setUploadedDocumentOwnerShipAndCSChart:
                setUploadedDocumentOwnerShipAndCSChart,
              uploadedDocumentHashOwnerShipAndCSChart:
                uploadedDocumentHashOwnerShipAndCSChart,
              setUploadedDocumentHashOwnerShipAndCSChart:
                setUploadedDocumentHashOwnerShipAndCSChart,
              uploadPercentageOwnerShipAndCSChart:
                uploadPercentageOwnerShipAndCSChart,
              setUploadPercentageOwnerShipAndCSChart:
                setUploadPercentageOwnerShipAndCSChart,
              uploadedDocumentRegisterOfDirectors:
                uploadedDocumentRegisterOfDirectors,
              setUploadedDocumentRegisterOfDirectors:
                setUploadedDocumentRegisterOfDirectors,
              uploadedDocumentHashRegisterOfDirectors:
                uploadedDocumentHashRegisterOfDirectors,
              setUploadedDocumentHashRegisterOfDirectors:
                setUploadedDocumentHashRegisterOfDirectors,
              uploadPercentageRegisterOfDirectors:
                uploadPercentageRegisterOfDirectors,
              setUploadPercentageRegisterOfDirectors:
                setUploadPercentageRegisterOfDirectors,
              uploadedDocumentSignatoryList: uploadedDocumentSignatoryList,
              setUploadedDocumentSignatoryList:
                setUploadedDocumentSignatoryList,
              uploadedDocumentHashSignatoryList:
                uploadedDocumentHashSignatoryList,
              setUploadedDocumentHashSignatoryList:
                setUploadedDocumentHashSignatoryList,
              uploadPercentageSignatoryList: uploadPercentageSignatoryList,
              setUploadPercentageSignatoryList:
                setUploadPercentageSignatoryList,
              uploadedDocumentIdOfDirectors: uploadedDocumentIdOfDirectors,
              setUploadedDocumentIdOfDirectors:
                setUploadedDocumentIdOfDirectors,
              uploadedDocumentHashIdOfDirectors:
                uploadedDocumentHashIdOfDirectors,
              setUploadedDocumentHashIdOfDirectors:
                setUploadedDocumentHashIdOfDirectors,
              uploadPercentageIdOfDirectors: uploadPercentageIdOfDirectors,
              setUploadPercentageIdOfDirectors:
                setUploadPercentageIdOfDirectors,
              uploadedDocumentFATCACRS: uploadedDocumentFATCACRS,
              setUploadedDocumentFATCACRS: setUploadedDocumentFATCACRS,
              uploadedDocumentHashFATCACRS: uploadedDocumentHashFATCACRS,
              setUploadedDocumentHashFATCACRS: setUploadedDocumentHashFATCACRS,
              uploadPercentageFATCACRS: uploadPercentageFATCACRS,
              setUploadPercentageFATCACRS: setUploadPercentageFATCACRS,
              uploadedDocumentAMLPolicy: uploadedDocumentAMLPolicy,
              setUploadedDocumentAMLPolicy: setUploadedDocumentAMLPolicy,
              uploadedDocumentHashAMLPolicy: uploadedDocumentHashAMLPolicy,
              setUploadedDocumentHashAMLPolicy:
                setUploadedDocumentHashAMLPolicy,
              uploadPercentageAMLPolicy: uploadPercentageAMLPolicy,
              setUploadPercentageAMLPolicy: setUploadPercentageAMLPolicy,
              uploadedDocumentAnnualReport: uploadedDocumentAnnualReport,
              setUploadedDocumentAnnualReport: setUploadedDocumentAnnualReport,
              uploadedDocumentHashAnnualReport:
                uploadedDocumentHashAnnualReport,
              setUploadedDocumentHashAnnualReport:
                setUploadedDocumentHashAnnualReport,
              uploadPercentageAnnualReport: uploadPercentageAnnualReport,
              setUploadPercentageAnnualReport: setUploadPercentageAnnualReport,
              selectedTinSec: selectedTinSec,
              setSelectedTinSec: setSelectedTinSec,
              uploadedDocumentTax: uploadedDocumentTax,
              setUploadedDocumentTax: setUploadedDocumentTax,
              uploadedDocumentHashTax: uploadedDocumentHashTax,
              setUploadedDocumentHashTax: setUploadedDocumentHashTax,
              uploadPercentageTax: uploadPercentageTax,
              setUploadPercentageTax: setUploadPercentageTax,
              selectedUserType: selectedUserType,
              setSelectedUserType: setSelectedUserType,
              inputWallet1: inputWallet1,
              setInputWallet1: setInputWallet1,
              inputWallet2: inputWallet2,
              setInputWallet2: setInputWallet2,
              inputWallet3: inputWallet3,
              setInputWallet3: setInputWallet3,
              inputWallet4: inputWallet4,
              setInputWallet4: setInputWallet4,
              inputName: inputName,
              setInputName: setInputName,
              inputEmail: inputEmail,
              setInputEmail: setInputEmail,
              inputDate: inputDate,
              setInputDate: setInputDate,
              inputWebsite: inputWebsite,
              setInputWebsite: setInputWebsite,
              inputAddress: inputAddress,
              setInputAddress: setInputAddress,
            }}
          />
        )}

        {showPartners && (
          <PartnerQuestionaireOverlay
            formStates={{
              _kycQuestionaire: _kycQuestionaire,
              _setKycQuestionaire: _setKycQuestionaire,
              isCheckboxClicked: isCheckboxClicked,
              setIsCheckboxClicked: setIsCheckboxClicked,
              partnerUploadPercentageAnnualReport:
                partnerUploadPercentageAnnualReport,
              setPartnerUploadPercentageAnnualReport:
                setPartnerUploadPercentageAnnualReport,
              partnerUploadedDocumentHashAnnualReport:
                partnerUploadedDocumentHashAnnualReport,
              setPartnerUploadedDocumentHashAnnualReport:
                setPartnerUploadedDocumentHashAnnualReport,
              partnerUploadedDocumentAnnualReport:
                partnerUploadedDocumentAnnualReport,
              setPartnerUploadedDocumentAnnualReport:
                setPartnerUploadedDocumentAnnualReport,
              partnerUploadPercentageAMLPolicy:
                partnerUploadPercentageAMLPolicy,
              setPartnerUploadPercentageAMLPolicy:
                setPartnerUploadPercentageAMLPolicy,
              partnerUploadedDocumentHashAMLPolicy:
                partnerUploadedDocumentHashAMLPolicy,
              setPartnerUploadedDocumentHashAMLPolicy:
                setPartnerUploadedDocumentHashAMLPolicy,
              partnerUploadedDocumentAMLPolicy:
                partnerUploadedDocumentAMLPolicy,
              setPartnerUploadedDocumentAMLPolicy:
                setPartnerUploadedDocumentAMLPolicy,
              partnerUploadPercentageFATCACRS: partnerUploadPercentageFATCACRS,
              setPartnerUploadPercentageFATCACRS:
                setPartnerUploadPercentageFATCACRS,
              partnerUploadedDocumentHashFATCACRS:
                partnerUploadedDocumentHashFATCACRS,
              setPartnerUploadedDocumentHashFATCACRS:
                setPartnerUploadedDocumentHashFATCACRS,
              partnerUploadedDocumentFATCACRS: partnerUploadedDocumentFATCACRS,
              setPartnerUploadedDocumentFATCACRS:
                setPartnerUploadedDocumentFATCACRS,
              partnerUploadPercentageIdOfDirectors:
                partnerUploadPercentageIdOfDirectors,
              setPartnerUploadPercentageIdOfDirectors:
                setPartnerUploadPercentageIdOfDirectors,
              partnerUploadedDocumentHashIdOfDirectors:
                partnerUploadedDocumentHashIdOfDirectors,
              setPartnerUploadedDocumentHashIdOfDirectors:
                setPartnerUploadedDocumentHashIdOfDirectors,
              partnerUploadedDocumentIdOfDirectors:
                partnerUploadedDocumentIdOfDirectors,
              setPartnerUploadedDocumentIdOfDirectors:
                setPartnerUploadedDocumentIdOfDirectors,
              partnerUploadPercentageSignatoryList:
                partnerUploadPercentageSignatoryList,
              setPartnerUploadPercentageSignatoryList:
                setPartnerUploadPercentageSignatoryList,
              partnerUploadedDocumentHashSignatoryList:
                partnerUploadedDocumentHashSignatoryList,
              setPartnerUploadedDocumentHashSignatoryList:
                setPartnerUploadedDocumentHashSignatoryList,
              partnerUploadedDocumentSignatoryList:
                partnerUploadedDocumentSignatoryList,
              setPartnerUploadedDocumentSignatoryList:
                setPartnerUploadedDocumentSignatoryList,
              partnerUploadPercentageRegisterOfDirectors:
                partnerUploadPercentageRegisterOfDirectors,
              setPartnerUploadPercentageRegisterOfDirectors:
                setPartnerUploadPercentageRegisterOfDirectors,
              partnerUploadedDocumentHashRegisterOfDirectors:
                partnerUploadedDocumentHashRegisterOfDirectors,
              setPartnerUploadedDocumentHashRegisterOfDirectors:
                setPartnerUploadedDocumentHashRegisterOfDirectors,
              partnerUploadedDocumentRegisterOfDirectors:
                partnerUploadedDocumentRegisterOfDirectors,
              setPartnerUploadedDocumentRegisterOfDirectors:
                setPartnerUploadedDocumentRegisterOfDirectors,
              partnerUploadPercentageOwnerShipAndCSChart:
                partnerUploadPercentageOwnerShipAndCSChart,
              setPartnerUploadPercentageOwnerShipAndCSChart:
                setPartnerUploadPercentageOwnerShipAndCSChart,
              partnerUploadedDocumentHashOwnerShipAndCSChart:
                partnerUploadedDocumentHashOwnerShipAndCSChart,
              setPartnerUploadedDocumentHashOwnerShipAndCSChart:
                setPartnerUploadedDocumentHashOwnerShipAndCSChart,
              partnerUploadedDocumentOwnerShipAndCSChart:
                partnerUploadedDocumentOwnerShipAndCSChart,
              setPartnerUploadedDocumentOwnerShipAndCSChart:
                setPartnerUploadedDocumentOwnerShipAndCSChart,
              partnerUploadPercentageArticlesOfAssociation:
                partnerUploadPercentageArticlesOfAssociation,
              setPartnerUploadPercentageArticlesOfAssociation:
                setPartnerUploadPercentageArticlesOfAssociation,
              partnerUploadedDocumentHashArticlesOfAssociation:
                partnerUploadedDocumentHashArticlesOfAssociation,
              setPartnerUploadedDocumentHashArticlesOfAssociation:
                setPartnerUploadedDocumentHashArticlesOfAssociation,
              partnerUploadedDocumentArticlesOfAssociation:
                partnerUploadedDocumentArticlesOfAssociation,
              setPartnerUploadedDocumentArticlesOfAssociation:
                setPartnerUploadedDocumentArticlesOfAssociation,
              partnerUploadPercentageProofOfRegulation:
                partnerUploadPercentageProofOfRegulation,
              setPartnerUploadPercentageProofOfRegulation:
                setPartnerUploadPercentageProofOfRegulation,
              partnerUploadedDocumentHashProofOfRegulation:
                partnerUploadedDocumentHashProofOfRegulation,
              setPartnerUploadedDocumentHashProofOfRegulation:
                setPartnerUploadedDocumentHashProofOfRegulation,
              partnerUploadedDocumentProofOfRegulation:
                partnerUploadedDocumentProofOfRegulation,
              setPartnerUploadedDocumentProofOfRegulation:
                setPartnerUploadedDocumentProofOfRegulation,
              partnerUploadPercentageUBO: partnerUploadPercentageUBO,
              setPartnerUploadPercentageUBO: setPartnerUploadPercentageUBO,
              partnerUploadedDocumentHashUBO: partnerUploadedDocumentHashUBO,
              setPartnerUploadedDocumentHashUBO:
                setPartnerUploadedDocumentHashUBO,
              partnerUploadedDocumentUBO: partnerUploadedDocumentUBO,
              setPartnerUploadedDocumentUBO: setPartnerUploadedDocumentUBO,
              partnerUploadPercentageUBOSource:
                partnerUploadPercentageUBOSource,
              setPartnerUploadPercentageUBOSource:
                setPartnerUploadPercentageUBOSource,
              partnerUploadedDocumentHashUBOSource:
                partnerUploadedDocumentHashUBOSource,
              setPartnerUploadedDocumentHashUBOSource:
                setPartnerUploadedDocumentHashUBOSource,
              partnerUploadedDocumentUBOSource:
                partnerUploadedDocumentUBOSource,
              setPartnerUploadedDocumentUBOSource:
                setPartnerUploadedDocumentUBOSource,
              partnerUploadPercentageW8: partnerUploadPercentageW8,
              setPartnerUploadPercentageW8: setPartnerUploadPercentageW8,
              partnerUploadedDocumentHashW8: partnerUploadedDocumentHashW8,
              setPartnerUploadedDocumentHashW8:
                setPartnerUploadedDocumentHashW8,
              partnerUploadedDocumentW8: partnerUploadedDocumentW8,
              setPartnerUploadedDocumentW8: setPartnerUploadedDocumentW8,
              partnerInputAddress: partnerInputAddress,
              setPartnerInputAddress: setPartnerInputAddress,
              partnerInputWebsite: partnerInputWebsite,
              setPartnerInputWebsite: setPartnerInputWebsite,
              partnerInputDate: partnerInputDate,
              setPartnerInputDate: setPartnerInputDate,
              partnerInputEmail: partnerInputEmail,
              setPartnerInputEmail: setPartnerInputEmail,
              partnerInputName: partnerInputName,
              setPartnerInputName: setPartnerInputName,
              partnerIdx: partnerIdx,
              setPartnerIdx: setPartnerIdx,
              entityType: entityType,
              setEntityType: setEntityType,
              partnersDetails: partnersDetails,
              setPartnersDetails: setPartnersDetails,
              moreComapnies: moreComapnies,
              setMoreCompanies: setMoreCompanies,
              partnerSelectedCountryInc: partnerSelectedCountryInc,
              setPartnerSelectedCountryInc: setPartnerSelectedCountryInc,
              countryList: countryList,
              setCountryList: setCountryList,
              partnerStep: partnerStep,
              setPartnerStep: setPartnerStep,
              showPartners: showPartners,
              setShowPartners: setShowPartners,
              includeEntity: includeEntity,
              setIncludeEntity: setIncludeEntity,
            }}
          />
        )}

        {!showPartners && (
          <React.Fragment>
            {selectedUserType !== "" && (
              <React.Fragment>
                <p className="verify-kyc-footer-text">{t("kyc.pepStatus")}</p>
                <p
                  style={{
                    fontWeight: "300",
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                    maxWidth: "300px",
                  }}
                  className="select-bank-popup-body-content-text"
                >
                  <span className="select-bank-popup-body-content-text">
                    {/* I/We confirm that I/we have read the definition of a
                    Politically Exposed Person (“PEP”) as set by Financial
                    Action Task Force (FATF) AML/CFT standards and
                    IFSCA/2022-23/GN/GL001.—International Financial Services
                    Centres Authority (Anti Money Laundering, Counter-Terrorist
                    Financing and Know Your Customer) Guidelines, 2022. */}
                    {t("kyc.pepConfirm1")}
                  </span>

                  <span className="select-bank-popup-body-content-text">
                    {/* I/We confirm that I/none of the individuals detailed in this
                    due diligence requirements questionnaire am/are now, and
                    never have been, a PEP. */}
                    {t("kyc.pepConfirm2")}
                  </span>

                  <span className="select-bank-popup-body-content-text">
                    {/* I/We confirm that no member of my immediate family or any of
                    my/our close associates, as those terms are defined by
                    FATF/IFSCA, is or ever been a PEP. */}
                    {t("kyc.pepConfirm3")}
                  </span>

                  <span className="select-bank-popup-body-content-text">
                    {/* If you/any individual detailed in this Due Diligence
                    Requirements Form are PEPs, then please provide details of
                    individual and role here. */}
                    {t("kyc.pepConfirm4")}
                  </span>

                  <span className="select-bank-popup-body-content-text">
                    {/* I/We undertake to advise you immediately with relevant
                    details, if anything should cause the confirmations give
                    here to change. */}
                    {t("kyc.pepConfirm5")}
                  </span>
                </p>
                <div className="profile-edit-contact-body">
                  <textarea
                    name="pep-input"
                    style={{
                      border: "1px solid var(--Neutral-100, #eeeef0)",
                      background: "transparent",
                      fontWeight: "500",
                      minHeight: "60px",
                      width: "100%",
                    }}
                    value={inputPep}
                    onInput={async (e) => {
                      setInputPep(e.target.value);
                      let kycQuestionaireLc =
                        JSON.parse(
                          localStorage.getItem(
                            `${userAddress?.toLowerCase()}-kyc-aml`,
                          ),
                        ) || {};
                      kycQuestionaireLc["inputPep"] = await encryptKycString(
                        e.target.value,
                      );

                      _setKycQuestionaire((prev) => ({
                        ...prev,
                        inputPep: e.target.value,
                      }));
                      localStorage.setItem(
                        `${userAddress?.toLowerCase()}-kyc-aml`,
                        JSON.stringify({
                          ...kycQuestionaireLc,
                          lastUpdated: Date.now(),
                        }),
                      );
                    }}
                    type="text"
                    className="offer-security-popup-input"
                    placeholder={t("placeholder.detailOrIConfirm")}
                  ></textarea>
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </div>

      {!showPartners &&
        selectedUserType?.length > 0 &&
        !nonCompany.includes(selectedUserType) &&
        moreComapnies !== "No" && (
          <button
            style={{ marginTop: "50px", marginBottom: "50px" }}
            id="add-funds-popup-button"
            className="startup-button-active"
            onClick={async () => {
              if (!selectedCountry?.name) {
                errorToast(
                  "Invalid Tax Residency",
                  "Select a valid tax residency",
                );
                return;
              }
              if (selectedOtherTax === "yes" && !selectedCountrySec?.name) {
                errorToast(
                  "Invalid Tax Residency",
                  "Select a valid tax residency",
                );
                return;
              }
              if (selectedTin === "") {
                errorToast(
                  "Invalid TIN/Equivalent",
                  "Select Yes or No for TIN/Equivalent",
                );
                return;
              }
              if (selectedTin === "") {
                errorToast(
                  "Invalid TIN/Equivalent",
                  "Select Yes or No for TIN/Equivalent",
                );
                return;
              }

              if (selectedTin === "yes" && inputTin === "") {
                errorToast(
                  "Invalid TIN/Equivalent",
                  "Input a valid TIN/Equivalent",
                );
                return;
              }

              if (
                selectedTin === "yes" &&
                uploadedDocumentHashTax?.length === 0
              ) {
                errorToast(
                  "Invalid TIN/Equivalent document",
                  "Upload a valid TIN/Equivalent document",
                );
                return;
              }

              if (selectedTin === "no" && selectedNoTin === "") {
                errorToast(
                  "Invalid reason for no TIN/Equivalent",
                  "Select a valid reason why you have no TIN/Equivalent",
                );
                return;
              }
              if (
                selectedTin === "no" &&
                selectedNoTin ===
                  "It is impossible for the above mentioned Client to obtain a TIN for the following reason" &&
                inputNoTin === ""
              ) {
                errorToast(
                  "Invalid reason for no TIN/Equivalent",
                  "Input a valid reason why it is impossible to obtain TIN/Equivalent",
                );
                return;
              }

              if (selectedUserType === "") {
                errorToast("Invalid User Type", "Select a valid user type.");
                return;
              }
              if (inputPep === "") {
                errorToast("Invalid PEP status", "Input a valid PEP status");
                return;
              }
              setShowPartners(true);
              // setPartnerStep("1");
              // setPartnerIdx(0);

              setPartnerStep(partnersDetails?.length > 0 ? "3" : "1");
              setMoreCompanies(partnersDetails?.length > 0 ? "Yes" : "");
              clearAllPartnerTempFiles();
              setPartnerIdx(0);
              if (partnersDetails?.length > 0) {
                setIncludeEntity(true);
                const popupDiv = document.getElementById("popup-scroll-div");
                if (popupDiv) {
                  popupDiv?.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                }
              }
            }}
          >
            <p className="add-funds-popup-a-f-button-text">
              {t("common.proceed")}
            </p>
          </button>
        )}

      {!showPartners &&
        selectedUserType?.length > 0 &&
        !nonCompany.includes(selectedUserType) &&
        moreComapnies === "No" && (
          <React.Fragment>
            <button
              style={{ marginTop: "50px" }}
              id="add-funds-popup-button"
              className="startup-button-active"
              onClick={async () => {
                await handleUploadQuestioaire();
              }}
            >
              <p className="add-funds-popup-a-f-button-text">Submit KYC</p>
            </button>

            <button
              style={{ marginBottom: "50px", marginTop: "10px" }}
              id="add-funds-popup-button"
              className="startup-button-click"
              onClick={async () => {
                if (!selectedCountry?.name) {
                  errorToast(
                    "Invalid Tax Residency",
                    "Select a valid tax residency",
                  );
                  return;
                }
                if (selectedOtherTax === "yes" && !selectedCountrySec?.name) {
                  errorToast(
                    "Invalid Tax Residency",
                    "Select a valid tax residency",
                  );
                  return;
                }
                if (selectedTin === "") {
                  errorToast(
                    "Invalid TIN/Equivalent",
                    "Select Yes or No for TIN/Equivalent",
                  );
                  return;
                }
                if (selectedTin === "") {
                  errorToast(
                    "Invalid TIN/Equivalent",
                    "Select Yes or No for TIN/Equivalent",
                  );
                  return;
                }

                if (selectedTin === "yes" && inputTin === "") {
                  errorToast(
                    "Invalid TIN/Equivalent",
                    "Input a valid TIN/Equivalent",
                  );
                  return;
                }

                if (
                  selectedTin === "yes" &&
                  uploadedDocumentHashTax?.length === 0
                ) {
                  errorToast(
                    "Invalid TIN/Equivalent document",
                    "Upload a valid TIN/Equivalent document",
                  );
                  return;
                }

                if (selectedTin === "no" && selectedNoTin === "") {
                  errorToast(
                    "Invalid reason for no TIN/Equivalent",
                    "Select a valid reason why you have no TIN/Equivalent",
                  );
                  return;
                }
                if (
                  selectedTin === "no" &&
                  selectedNoTin ===
                    "It is impossible for the above mentioned Client to obtain a TIN for the following reason" &&
                  inputNoTin === ""
                ) {
                  errorToast(
                    "Invalid reason for no TIN/Equivalent",
                    "Input a valid reason why it is impossible to obtain TIN/Equivalent",
                  );
                  return;
                }

                if (selectedUserType === "") {
                  errorToast("Invalid User Type", "Select a valid user type.");
                  return;
                }
                if (inputPep === "") {
                  errorToast("Invalid PEP status", "Input a valid PEP status");
                  return;
                }
                setShowPartners(true);
                setPartnerStep(partnersDetails?.length > 0 ? "3" : "1");
                setMoreCompanies(partnersDetails?.length > 0 ? "Yes" : "");
                clearAllPartnerTempFiles();
                setPartnerIdx(0);
                setEntityType("");
                setIncludeEntity(true);
                const popupDiv = document.getElementById("popup-scroll-div");
                if (popupDiv) {
                  popupDiv?.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                }
              }}
            >
              <p className="add-funds-popup-a-f-button-text">
                {t("common.proceed")}{" "}
              </p>
            </button>
          </React.Fragment>
        )}

      {showPartners &&
        selectedUserType?.length > 0 &&
        !nonCompany.includes(selectedUserType) &&
        moreComapnies === "Yes" &&
        Number(partnerStep) > 2 && (
          <React.Fragment>
            <button
              style={{ marginTop: "50px" }}
              id="add-funds-popup-button"
              className="startup-button-active"
              onClick={async () => {
                await handleUploadQuestioaire();
              }}
            >
              <p className="add-funds-popup-a-f-button-text">Submit KYC</p>
            </button>

            {partnerIdx + 1 >= partnersDetails?.length && (
              <button
                style={{ marginBottom: "50px", marginTop: "10px" }}
                id="add-funds-popup-button"
                className="startup-button-click"
                onClick={async () => {
                  setShowPartners(true);
                  setPartnerStep("1");
                  setMoreCompanies("");
                  setPartnerIdx(
                    partnersDetails?.length > 0 ? partnersDetails?.length : 0,
                  );
                  setEntityType("");
                  setMoreCompanies("");
                  clearAllPartnerTempFiles();
                }}
              >
                <p className="add-funds-popup-a-f-button-text">Add More </p>
              </button>
            )}

            {partnerIdx + 1 < partnersDetails?.length && (
              <button
                style={{ marginBottom: "50px", marginTop: "10px" }}
                id="add-funds-popup-button"
                className="startup-button-click"
                onClick={async () => {
                  setShowPartners(true);
                  setPartnerStep(partnersDetails?.length > 0 ? "3" : "1");
                  setMoreCompanies(partnersDetails?.length > 0 ? "Yes" : "");
                  clearAllPartnerTempFiles();
                  setPartnerIdx(partnerIdx + 1);
                  setIncludeEntity(true);
                  const popupDiv = document.getElementById("popup-scroll-div");
                  if (popupDiv) {
                    popupDiv?.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  }
                }}
              >
                <p className="add-funds-popup-a-f-button-text">
                  {t("common.proceed")}
                </p>
              </button>
            )}
          </React.Fragment>
        )}

      {!showPartners && selectedUserType === "" && (
        <button
          style={{ marginTop: "50px", marginBottom: "50px" }}
          id="add-funds-popup-button"
          className="startup-button-active"
          onClick={async () => {
            await handleUploadQuestioaire();
          }}
        >
          <p className="add-funds-popup-a-f-button-text">Submit KYC</p>
        </button>
      )}

      {!showPartners && nonCompany.includes(selectedUserType) && (
        <button
          style={{ marginTop: "50px", marginBottom: "50px" }}
          id="add-funds-popup-button"
          className="startup-button-active"
          onClick={async () => {
            await handleUploadQuestioaire();
          }}
        >
          <p className="add-funds-popup-a-f-button-text">Submit KYC</p>
        </button>
      )}
    </div>
  );
};

export default KYCQuestionnaire;
